window.CarouselHeroVideoPlayer = window.CarouselHeroVideoPlayer || (function () {
  function isElementVisible(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function getScopedSections(scope) {
    if (!scope) {
      return Array.from(document.querySelectorAll('[data-hero-section]'));
    }

    if (scope.matches && scope.matches('[data-hero-section]')) {
      return [scope];
    }

    return Array.from(scope.querySelectorAll('[data-hero-section]'));
  }

  function initVideoVisibility(root) {
    const heroSections = getScopedSections(root || document);

    heroSections.forEach(function (heroSection) {
      if (heroSection.dataset.videoVisibilityBound === 'true') {
        return;
      }

      const videos = Array.from(heroSection.querySelectorAll('video.video-desktop, video.video-mobile'));
      if (!videos.length) {
        heroSection.dataset.videoVisibilityBound = 'true';
        return;
      }

      function getVisibleVideos() {
        return videos.filter(isElementVisible);
      }

      function syncMuteButtons() {
        heroSection.querySelectorAll('.hero-section__mute-button').forEach(function (button) {
          const hasUnmutedVisibleVideo = getVisibleVideos().some(function (video) {
            return !video.muted;
          });

          button.textContent = hasUnmutedVisibleVideo ? 'Sound on' : 'Sound off';
        });
      }

      function pauseAndMuteVideos() {
        videos.forEach(function (video) {
          video.muted = true;
          video.pause();
        });
        syncMuteButtons();
      }

      function playVisibleVideos() {
        getVisibleVideos().forEach(function (video) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        });
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== heroSection) {
              return;
            }

            if (entry.isIntersecting && entry.intersectionRatio > 0.2) {
              playVisibleVideos();
              return;
            }

            pauseAndMuteVideos();
          });
        }, {
          threshold: [0, 0.2, 0.35]
        });

        observer.observe(heroSection);
      } else {
        const handleVisibilityChange = function () {
          const rect = heroSection.getBoundingClientRect();
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          const isInView = rect.bottom > viewportHeight * 0.2 && rect.top < viewportHeight * 0.8;

          if (isInView) {
            playVisibleVideos();
            return;
          }

          pauseAndMuteVideos();
        };

        window.addEventListener('scroll', handleVisibilityChange, { passive: true });
        window.addEventListener('resize', handleVisibilityChange);
        handleVisibilityChange();
      }

      heroSection.dataset.videoVisibilityBound = 'true';
    });
  }

  function initMuteButtons(root) {
    const scope = root || document;

    scope.querySelectorAll('.hero-section__mute-button').forEach(function (button) {
      if (button.dataset.muteBound === 'true') {
        return;
      }

      const slide = button.closest('.carousel-slide');
      if (!slide) {
        return;
      }

      function getVideos() {
        return Array.from(slide.querySelectorAll('video.video-desktop, video.video-mobile'));
      }

      function getVideoLabel(video) {
        if (video.classList.contains('video-desktop')) {
          return 'desktop';
        }
        if (video.classList.contains('video-mobile')) {
          return 'mobile';
        }
        return 'unknown';
      }

      function logVideoStates(context) {
        getVideos().forEach(function (video) {
          console.log('[hero-video]', context, {
            videoType: getVideoLabel(video),
            paused: video.paused,
            ended: video.ended,
            muted: video.muted,
            currentTime: Number(video.currentTime || 0).toFixed(2),
            visible: isElementVisible(video)
          });
        });
      }

      function getActiveVideos() {
        const playingVideos = getVideos().filter(function (video) {
          return !video.paused && !video.ended;
        });

        return playingVideos.length ? playingVideos : getVideos();
      }

      function syncButtonText() {
        const activeVideos = getActiveVideos();
        const hasUnmutedVideo = activeVideos.some(function (video) {
          return !video.muted;
        });

        button.textContent = hasUnmutedVideo ? 'Sound on' : 'Sound off';
      }

      button.addEventListener('click', function () {
        const activeVideos = getActiveVideos();
        if (!activeVideos.length) {
          console.log('[hero-video] mute click ignored: no videos found');
          return;
        }

        const shouldMute = activeVideos.some(function (video) {
          return !video.muted;
        });

        console.log('[hero-video] mute button click', {
          targetVideos: activeVideos.map(getVideoLabel),
          action: shouldMute ? 'mute' : 'unmute'
        });

        activeVideos.forEach(function (video) {
          video.muted = shouldMute;
        });

        syncButtonText();
        logVideoStates('after mute toggle');
      });

      getVideos().forEach(function (video) {
        video.addEventListener('volumechange', syncButtonText);
        video.addEventListener('play', function () {
          console.log('[hero-video] play event', { videoType: getVideoLabel(video), visible: isElementVisible(video) });
        });
        video.addEventListener('pause', function () {
          console.log('[hero-video] pause event', { videoType: getVideoLabel(video), visible: isElementVisible(video) });
        });
      });

      syncButtonText();
      logVideoStates('init');
      button.dataset.muteBound = 'true';
    });
  }

  function init(root) {
    initMuteButtons(root || document);
    initVideoVisibility(root || document);
  }

  return {
    init: init,
    initMuteButtons: initMuteButtons,
    initVideoVisibility: initVideoVisibility
  };
})();
